import React from 'react'

interface Props {
    children?: React.ReactNode
}

const CenterContainer: React.FC<Props> = props => {
    return <>{props.children}</>
}

export default CenterContainer
